import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../Pages/LandingPage/LandingPage";

// import KeeperApp from "../Keeper/KeeperApp";

function WebsiteApp() {
  return (
    <>
      <Routes>
        <Route path="/" index element={<LandingPage />} />
      </Routes>
      {/* <KeeperApp /> */}
    </>
  );
}

export default WebsiteApp;
